import {useSentryClientPluginSetup} from '../shared/client.config';

// This just need to be executed as it will be imported inside a plugin by Sentry SDK
useSentryClientPluginSetup();
